/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InactiveCleanupCriteriaDTOFromJSON, InactiveCleanupCriteriaDTOToJSON, } from './InactiveCleanupCriteriaDTO';
/**
 * @export
 */
export const InactiveCleanupStartRequestDTOChannelEnum = {
    Web: 'WEB',
    Extension: 'EXTENSION'
};
/**
 * Check if a given object implements the InactiveCleanupStartRequestDTO interface.
 */
export function instanceOfInactiveCleanupStartRequestDTO(value) {
    if (!('criteria' in value) || value['criteria'] === undefined)
        return false;
    if (!('expectedCount' in value) || value['expectedCount'] === undefined)
        return false;
    return true;
}
export function InactiveCleanupStartRequestDTOFromJSON(json) {
    return InactiveCleanupStartRequestDTOFromJSONTyped(json, false);
}
export function InactiveCleanupStartRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'criteria': InactiveCleanupCriteriaDTOFromJSON(json['criteria']),
        'expectedCount': json['expectedCount'],
        'channel': json['channel'] == null ? undefined : json['channel'],
    };
}
export function InactiveCleanupStartRequestDTOToJSON(json) {
    return InactiveCleanupStartRequestDTOToJSONTyped(json, false);
}
export function InactiveCleanupStartRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'criteria': InactiveCleanupCriteriaDTOToJSON(value['criteria']),
        'expectedCount': value['expectedCount'],
        'channel': value['channel'],
    };
}
